export function replaceToken(template, token, value) {
  const text = String(template || '');
  const replacement = String(value ?? '');

  // Function replacer, so "$" in the value is not treated as a replacement pattern.
  return text
    .replace(new RegExp(`\\$\\{\\{${token}\\}\\}`, 'g'), () => replacement)
    .replace(new RegExp(`\\$\\{${token}\\}`, 'g'), () => replacement)
    .replace(new RegExp(`\\{${token}\\}`, 'g'), () => replacement);
}
